import useProductStore from '@/stores/productStore';

const ReviewFiles = () => {
  const files = useProductStore(d => d.deliverables);

  return (
    <div>
      {files.length ? (
        files.map(f => <div key={f.id}>{f.filename}</div>)
      ) : (
        <div>Você ainda precisa enviar o arquivo que será entregue aos seus clientes após a compra.</div>
      )}
    </div>
  );
};

export default ReviewFiles;
